module.exports = "<div class=\"esign-loader\">\n\t<img src=\"src/assets/images/HERO-Logo.png\" />\n\t<h1>Finalizing Documents</h1>\n\t<p>Page will be automatically refreshed in a few seconds</p>\n\t<div class=\"scale-cont\">\n\t\t<div class=\"loading\"></div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/ESign/ESign.html
// module id = 577
// module chunks = 1